<template>
  <div class="d-flex justify-end mt-4 mr-4">
    
    
    <!-- Componente de Notificaciones -->
    <v-menu rounded offset-y max-width="400" min-width="300" max-height="calc(100vh - 205px)"
      :close-on-content-click="false" transition="slide-y-transition" bottom left>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-badge :value="showBadge" color="#FF7900" dot overlap class="float-right">
              <v-btn color="#FF790080" elevation="0" fab x-small dark v-bind="attrs" v-on="{ ...tooltip, ...menu }"
                @click="actionShowBadge(false)">
                <v-icon>mdi-bell</v-icon>
              </v-btn>
            </v-badge>
          </template>
          <span>Notificaciones</span>
        </v-tooltip>
      </template>
 
      <v-card class="text-center">
        <headerComponent :cantidad="notifications.length" />
        <v-list two-line v-if="notifications.length">
          <notificationComponent v-for="(notification, index) in notifications" :key="index" :notification="notification"/>
          <v-divider v-if="notifications.length > 1"></v-divider>
        </v-list>
 
        <span v-else>Sin Notificaciones Pendientes ...</span>
      </v-card>
    </v-menu>
  </div>
</template>
 
<script>
import {
  NOTIFICATIONS_M,
  ACTION_LIST_NOTIFICATIONS,
  GET_NOTIFICATIONS,
  ACTION_SHOW_BADGE,
  GET_SHOW_BADGE,
} from "@/shared/components/notifications/store/types.js";
import { mapActions, mapGetters } from "vuex";
import pusher from "@/shared/directives/pusher.js";
import headerComponent from "@/shared/components/notifications/component/header/header.vue";
import notificationComponent from "@/shared/components/notifications/component/notification/notification.vue";
 
export default {
  name: "notification",
  components: {
    headerComponent,
    notificationComponent,
  },
  mounted() {
    this.listenPusher();
    //this.getActionNotifications();
  },
  destroyed() {
    pusher.disconnect();
  },
  computed: {
    ...mapGetters({
      notifications: [`${NOTIFICATIONS_M}${GET_NOTIFICATIONS}`],
      showBadge: [`${NOTIFICATIONS_M}${GET_SHOW_BADGE}`],
    }),
  },
  methods: {
    ...mapActions({
      getActionNotifications: `${NOTIFICATIONS_M}${ACTION_LIST_NOTIFICATIONS}`,
      actionShowBadge: `${NOTIFICATIONS_M}${ACTION_SHOW_BADGE}`,
    }),
    listenPusher() {
     /* try {
        var idUsuario = sessionStorage.getItem("idUsuario");
        var channel = pusher.subscribe("bflex");
        channel.bind("user-" + idUsuario, () => this.getActionNotifications());
      } catch (error) {
        console.error("error en pusher", error);
      }
      */
    },
  },
};
</script>
 
<style lang="css">
.v-badge--dot .v-badge__badge {
  border-radius:4.5px;
  height:6px;
  min-width: 0;
  padding: 0;
  width: 6px;
  margin: 0px 0px -7px -7px;
}
 
.brand-fixed {
  height: 6rem;
  width: 6rem;
}
 
::-webkit-scrollbar {
  width: 0.4em;
}
 
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 1em;
}
 
.d-flex {
  display: flex;
  align-items: center;
}
.d-flex > * {
  margin-right: 10px;
}
 
</style>